export default __webpack_public_path__ + "static/media/circle-arrow-right.c814227b.svg";